import React from 'react'
import styled, { withTheme } from 'styled-components'
import logo from '../../../img/logo.webp'

const Wrapper = styled.div`
    display: flex;
    height: 60px;
    width: 300px;
    background-color: white;
    padding: 8px;
    border-radius: 8px;
    text-align: center;
    border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lightGrey};

    img {
        display: flex;
        height: 100%;
    }
`

const Body = styled.div`
    display: flex;
    width: 100%;
`

const Text = styled.div`
    height: 9px;
    width: ${({ width }) => width || 100}%;
    background: ${(props) => props.theme.palette.greyScale.lighterGrey};
`

const Paragraph = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;

    ${Text}:last-child {
        margin-top: 7px;
    }
`

const Button = styled.div`
    align-self: flex-end;
    border-left: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
    width: 80px;
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    align-items: center;
`

export const Notification = ({ theme, value, label, title, wheelProps }) => (
    <Wrapper className="box-shadow">
        <Body>
            <img src={logo} alt="Keybreak logo" />
            <Paragraph>
                <Text />
                <Text width={60} />
            </Paragraph>
        </Body>
        <Button>
            <Text />
        </Button>
    </Wrapper>
)

export default withTheme(Notification)
